import { PlusOutlined, SearchOutlined } from '@ant-design/icons';
import { Button, Input, Select } from 'antd';
import React, { FC, useState, useContext } from 'react';
import ConfigHistoryIcon from '@/assets/images/public/config-history.react.svg?react';
import { isAndroid, isFlutter, isHarmonyOS, isIOS, isWindows } from '@/infrastructure/product-info';
import { Platform } from '@/infrastructure/utils/app';
import { PlatformContext } from '@/presentation/pages/setting/app-deliver-config';
import { ConfigTabType, isConfigManage } from '@/presentation/pages/setting/app-deliver-config/api';
import { EditConfigModal, OperationType } from '@/presentation/pages/setting/app-deliver-config/config-modal/edit';
import { HistoryConfigModal } from '@/presentation/pages/setting/app-deliver-config/config-modal/history';
import style from './index.module.scss';

export const PLATFORM_OPTIONS = [
  { label: 'Android', value: Platform.Android },
  { label: 'IOS', value: Platform.IOS },
  { label: 'Flutter', value: Platform.Flutter },
  { label: 'Windows', value: Platform.Windows },
  { label: 'HarmonyOS', value: Platform.HarmonyOS },
];

export const ConfigHeader: FC<{
  tab: ConfigTabType;
  configNum: number;
  update: () => void;
  defaultConfig: string;
  onSearch: (search: string) => void;
  isAdmin: boolean;
  configDocUrl?: string
}> = (props) => {
  const [searchData, setSearchData] = useState('');
  const [editVisible, setEditVisible] = useState(false);
  const [historyVisible, setHistoryVisible] = useState(false);
  const { tab, configNum, update, defaultConfig, onSearch, configDocUrl, isAdmin } = props;
  const { platform, setPlatform } = useContext(PlatformContext);

  const addNewConfig = () => {
    setEditVisible(true);
    update();
  };

  const onAddNewConfig = () => {
    setEditVisible(false);
    update();
  };

  return (
    <div className={style.headerContent}>
      <div className={style.headerLeft}>
        <div className={style.addBtn}>
          {(isAndroid() || isIOS() || isHarmonyOS() || (isFlutter() && tab === ConfigTabType.BUSINESS)
            || (isWindows() && tab === ConfigTabType.BUSINESS) || isConfigManage(tab))
            ? <Button
              type="primary"
              icon={<PlusOutlined className={style.addBtnIcon} />}
              onClick={addNewConfig}
              disabled={!isAdmin && !isConfigManage(tab)}
            >
              新建配置
            </Button> : null}
          <EditConfigModal
            visible={editVisible}
            type={OperationType.ADD}
            tab={tab}
            onChange={onAddNewConfig}
            onCancel={() => setEditVisible(false)}
            defaultConfig={defaultConfig}
          />
        </div>
        {configDocUrl ? <div className={style.addBtn}>
          <Button
            style={{ marginLeft: 10 }}
            type="primary"
            onClick={() => window.open(configDocUrl)}
          >
            查看配置文档
          </Button>
        </div> : null}
        <div className={style.taskNum}>
          共 {isNaN(configNum) ? 0 : configNum} 个任务
        </div>
      </div>
      <div className={style.headerRight}>
        <Button
          type={'link'}
          href={'https://docs.bugly.woa.com/quick_start/config/'}
          target={'_blank'}
        >
          配置使用指引
        </Button>
        {isConfigManage(tab) && <Select
            value={platform}
            options={PLATFORM_OPTIONS}
            onChange={val => setPlatform?.(val)}
            style={{ width: 120, marginRight: 10 }}
          />}
        <Input
          placeholder="输入任务名"
          allowClear
          onPressEnter={() => onSearch(searchData)}
          onChange={e => setSearchData(e.target.value)}
          suffix={
            <SearchOutlined
              style={{ cursor: 'pointer' }}
              onClick={() => onSearch(searchData)}
            />
          }
          style={{ width: '256px' }}
        />
        <Button
          hidden={tab === ConfigTabType.COMPLIANCE}
          onClick={() => setHistoryVisible(true)}
          style={{ marginLeft: 10, display: 'flex', alignItems: 'center' }}
        >
          <ConfigHistoryIcon />
          <span style={{ marginLeft: 10 }}>配置修改历史</span>
        </Button>
        <HistoryConfigModal
          visible={historyVisible}
          setVisible={setHistoryVisible}
          tab={tab}
        />
      </div>
    </div>
  );
};
